module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.indeterminate),
      callback: function($$v) {
        _vm.indeterminate = $$v
      },
      expression: "indeterminate"
    }
  }, [_vm._v(" Indeterminate ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Type and Size"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Type"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-danger"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('b-select', {
    attrs: {
      "placeholder": "Size"
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("Small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("Large")])])], 1)], 1), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_vm._v(" Show Value ")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.showValue
    },
    model: {
      value: (_vm.keepTrailingZeroes),
      callback: function($$v) {
        _vm.keepTrailingZeroes = $$v
      },
      expression: "keepTrailingZeroes"
    }
  }, [_vm._v(" Keep Trailing Zeroes ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Format and Precision"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.showValue
    },
    model: {
      value: (_vm.format),
      callback: function($$v) {
        _vm.format = $$v
      },
      expression: "format"
    }
  }, [_c('option', {
    attrs: {
      "value": "raw"
    }
  }, [_vm._v("Raw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percent")])]), _vm._v(" "), _c('b-numberinput', {
    attrs: {
      "disabled": !_vm.showValue,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.precision),
      callback: function($$v) {
        _vm.precision = $$v
      },
      expression: "precision"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": _vm.type,
      "size": _vm.size,
      "value": _vm.indeterminate ? undefined : 80,
      "show-value": _vm.showValue,
      "format": _vm.format,
      "precision": _vm.precision,
      "keep-trailing-zeroes": _vm.keepTrailingZeroes
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a99c0cb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/progress/examples/ExValues.vue
// module id = 1152
// module chunks = 25 109